import { delayAnimation } from "common/promises";
export async function endingEffect({ root }) {
    const effector = new Effector(root);
    await effector.normal(2);
    await effector.invert(3);
    await effector.normal(2);
    await effector.blackScreen(2);
    await effector.redScreen(1);
    await effector.blueScreen(1);
    await effector.redFilter(1);
    await effector.blueFilter(3);
    await effector.redFilter(1);
    await effector.blueScreen(1);
    await effector.redScreen(2);
    await effector.redFilter(1);
    await effector.blueFilter(1);
    await effector.redScreen(1);
    await effector.blueScreen(2);
    effector.blackForever();
}
async function delayFrame(frameNum) {
    await delayAnimation(frameNum * 33);
}
class Effector {
    constructor(element) {
        this.element = $(element);
        const frontScreen = $(`<div class="absolute w-100 h-100"></div>`);
        this.element.append(frontScreen);
        this.frontScreen = frontScreen;
    }
    async invert(frameNum) {
        await this.addClassForFrames({ className: "invert", frameNum });
    }
    async normal(frameNum) {
        await delayFrame(frameNum);
    }
    async blackScreen(frameNum) {
        await this.styleForFrames({
            frameNum,
            style: new Map([["background", "black"]]),
        });
    }
    async blueScreen(frameNum) {
        await this.styleForFrames({
            frameNum,
            style: new Map([["background", "blue"]]),
        });
    }
    async redScreen(frameNum) {
        await this.styleForFrames({
            frameNum,
            style: new Map([["background", "red"]]),
        });
    }
    async blueFilter(frameNum) {
        await this.styleForFrames({
            frameNum,
            style: new Map([
                ["background", "blue"],
                ["opacity", "0.3"],
            ]),
        });
    }
    async redFilter(frameNum) {
        await this.styleForFrames({
            frameNum,
            style: new Map([
                ["background", "red"],
                ["opacity", "0.3"],
            ]),
        });
    }
    async blackForever() {
        this.frontScreen.css("background", "black");
    }
    async styleForFrames({ style, frameNum, }) {
        for (const [key, value] of style) {
            this.frontScreen.css(key, value);
        }
        await delayFrame(frameNum);
        for (const key of style.keys()) {
            this.frontScreen.css(key, "");
        }
    }
    async addClassForFrames({ frameNum, className, }) {
        this.element.addClass(className);
        await delayFrame(frameNum);
        this.element.removeClass(className);
    }
}
//# sourceMappingURL=endingEffect.js.map